import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { verifyRegistrationEmail } from 'redux/users/actions';

import {Link, Redirect} from 'react-router-dom';

import CommonMessage from 'components/common/CommonMessage';
import CommonLoader from 'components/common/CommonLoader';


const EmailVerificationContent = props => {
  const {
    verificationKey,
    accessToken,
    verifyRegistrationEmail,
    verifyRegistrationEmailSuccess,
    verifyRegistrationEmailError,
  } = props;

  useEffect(() => {
    verifyRegistrationEmail(verificationKey);
  }, []);

  if (verifyRegistrationEmailSuccess && accessToken) {
    return <Redirect to="/" />;
  }

  const verificationErrorMessage = [(
    <div>
      <p>Oops… We can’t verify your email. Maybe it was already verified.
        If the issue remains, please send us an email: team@heylink.me</p>
      <p>You can log in <Link to="/login">here</Link></p>
      <p>If you forgot your password, you can reset it <Link to="/password-recovery">here</Link></p>
    </div>
  )];

  return (
    <div className="email-verification-content__component">
      <CommonLoader active={!accessToken && !verifyRegistrationEmailError} />

      <h1>Email Verification Results</h1>

      {verifyRegistrationEmailError &&
        <CommonMessage
          error
          errors={verificationErrorMessage}
        />
      }
    </div>
  );
};

EmailVerificationContent.propTypes = {
  verifyRegistrationEmail: PropTypes.func.isRequired,
  verificationKey: PropTypes.string.isRequired,
  accessToken: PropTypes.string,
  verifyRegistrationEmailSuccess: PropTypes.object,
  verifyRegistrationEmailError: PropTypes.object,
};

EmailVerificationContent.defaultProps = {
  accessToken: null,
  verifyRegistrationEmailSuccess: false,
  verifyRegistrationEmailError: null,
};

const mapStateToProps = state => (
  {
    accessToken: state.usersReducer.accessToken,
    verifyRegistrationEmailSuccess: state.usersReducer.verifyRegistrationEmailSuccess,
    verifyRegistrationEmailError: state.usersReducer.verifyRegistrationEmailError,
  }
);

export default connect(
  mapStateToProps,
  {
    verifyRegistrationEmail,
  },
)(EmailVerificationContent);
